import Swiper from "swiper";
import { initIntersectionObserver } from "@plugins";

const featuresWrapper = document.querySelector(".js-features-swiper-init");

if (featuresWrapper) {
    initIntersectionObserver(featuresWrapper, initFeaturesSlider);
}

function initFeaturesSlider(featuresWrapper) {
    const thumbsContainer = featuresWrapper.querySelector(".js-features-swiper-thumbs-container");
    const swiperContainer = featuresWrapper.querySelector(".js-features-swiper-container");

    const featuresThumbs = new Swiper(thumbsContainer, {
        spaceBetween: 28,
        slidesPerView: 3,
        observer: true,
        shortSwipes: false,
        watchOverflow: true,
    });

    new Swiper(swiperContainer, {
        spaceBetween: window.mobileMedia ? 17 : 10,

        navigation: {
            nextEl: ".js-features-swiper-controls .swiper-button-next",
            prevEl: ".js-features-swiper-controls .swiper-button-prev",
        },

        pagination: {
            el: ".js-features-swiper-controls .swiper-pagination",
            dynamicBullets: true,
            dynamicMainBullets: 3,
            clickable: true,
        },

        thumbs: {
            swiper: featuresThumbs,
            slideThumbActiveClass: "active",
        },
    });
}
